<script setup lang="ts">
const { siteOptions } = useSiteOptions();
</script>

<template>
  <a :href="siteOptions.checkout_url" class="btn-orange">Procéder au paiement</a>
</template>
